export const RenderCountrySelectedLabels = (Props: {
	options: Array<{ code: string | null; name: string }>
}) => {
	const { options } = Props
	return <div>{options.map((option) => option.name).join(', ')}</div>
}

export const RenderCountryLabel = (Props: {
	option: { name: string; value: string | null | boolean }
}) => {
	const { option } = Props
	return <span>{option.name}</span>
}
